// extracted by mini-css-extract-plugin
export default {"notificationSettingsInfo":"opZd","notificationSettings":"E+bq"};